export default __webpack_public_path__ + "static/media/Heat-Treatment-Vendors.8e064aeb.jpg";